"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
const ReplacesEnum_1 = require("../ReplacesEnum");
exports.Common = Object.freeze({
    EXTENSION_NAME: 'Omnito Meeting Booker: Nahtlose Terminplanung',
    EXTENSION_SHORT_NAME: 'Omnito Inbox',
    EXTENSION_DESCRIPTION: 'Vereinfache die Terminplanung! Verbinde mit einem Klick deinen Kalender, lege Verfügbarkeiten fest und sende Einladungen, damit du nie doppelt gebucht wirst.',
    EXTENSION_BUTTON_TOOLTIP: 'Omnito Meeting Booker einfügen',
    AUTHORIZATION_SERVER_ONE: 'Omnito',
    AUTHORIZATION_SERVER_SALESFORCE: 'Omnito für Salesforce (CEP)',
    AUTHORIZATION_SERVER_SALESFORCE_PRODUCTION: 'Produktion',
    AUTHORIZATION_SERVER_SALESFORCE_SANDBOX: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_SUMO1_LOGIN_TITLE: 'Omnito',
    ACTIVE_TAB_SIDEBAR_SALESFORCE_LOGIN_TITLE: 'Omnito für Salesforce',
    ACTIVE_TAB_SIDEBAR_LOGIN_BUTTON: 'Anmelden',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_GOOGLE_BUTTON: 'Mit Google anmelden',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_MICROSOFT_BUTTON: 'Mit Microsoft anmelden',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_BUTTON: 'Mit Salesforce anmelden',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_PRODUCTION_BUTTON: 'Produktion',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_SANDBOX_BUTTON: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_TEXT: 'Noch kein Konto?',
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_LINK: 'Registrieren',
    ACTIVE_TAB_SIDEBAR_CREATE_MEETING_BUTTON: 'Meeting erstellen',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN: 'Willkommen, du bist angemeldet.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN_CREATE_MEETING_BUTTON: 'Klicke auf „Meeting erstellen“, um Zeitfenster in deine E-Mail einzufügen.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_1: "1. Öffne <a target='_blank' class='text-blue-100 no-underline' href='https://mail.google.com'>Gmail.com</a> oder <a target='_blank' class='text-blue-100 no-underline' href='https://outlook.live.com'>Outlook.live.com</a> und erstelle eine neue E-Mail",
    GMAIL_URL: 'gmail.com',
    OUTLOOK_URL: 'outlook.live.com',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_2: '2. Klicke auf das Meeting Booker-Symbol',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_3: '3. Make booking faster. Connect your contacts to speed up booking.',
    ACTIVE_TAB_SIDEBAR_ALLOW_CONTACTS_ACCESS_BUTTON: 'Allow access',
    SCHEDULER_CONNECT_CONTACTS_BANNER_TITLE: 'Make booking faster',
    SCHEDULER_CONNECT_CONTACTS_BANNER_DESCRIPTION: 'Connect your Google Contacts to quickly find people and autofill meeting details.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LOGOUT_BUTTON: 'Abmelden',
    ACTIVE_TAB_SETTINGS_LOGOUT_BUTTON: 'Abmelden',
    SCHEDULER_DEFAULT_WORKSPACE_LABEL: 'Standardarbeitsbereich',
    SCHEDULER_WORKSPACE_LABEL: 'Arbeitsbereich',
    SCHEDULER_WORKSPACE_TOOLTIP: 'Die Liste der Dienste und Gastgeber wird basierend auf deinem ausgewählten Arbeitsbereich aktualisiert',
    SCHEDULER_SETTINGS_DEFAULT_PROCESS_LABEL: 'Standardprozess',
    SCHEDULER_SETTINGS_DEFAULT_HOST_LABEL: 'Standardgastgeber',
    SCHEDULER_SETTINGS_HOST_ME_LABEL: 'Ich',
    SCHEDULER_SETTINGS_HOST_NONE_LABEL: 'Keiner',
    SCHEDULER_SETTINGS_BUTTON: 'Einstellungen',
    SCHEDULER_SETTINGS_TOOLTIP: 'Einstellungen',
    SCHEDULER_MEETING_NAME_LABEL: 'Meeting-Name',
    SCHEDULER_APPOINTMENT_TITLE_LABEL: 'Termin-Titel / Typ',
    SCHEDULER_APPOINTMENT_TYPES_LABEL: 'Terminarten',
    SCHEDULER_APPOINTMENT_TYPES_PLACEHOLDER: 'Terminarten auswählen',
    SCHEDULER_APPOINTMENT_TYPES_SEARCH_PLACEHOLDER: 'Suchen',
    SCHEDULER_APPOINTMENT_TYPES_MAX_WARNING: `Maximal ${ReplacesEnum_1.ReplacesDetailEnum.MAX} können ausgewählt werden.`,
    SCHEDULER_APPOINTMENT_TITLE_ONLY_LABEL: 'Termintitel',
    SCHEDULER_APPOINTMENT_TITLE_ONLY_PLACEHOLDER: 'Termintitel eingeben',
    SCHEDULER_TITLE_PLACEHOLDER: 'Name eingeben',
    SCHEDULER_MEETING_TYPE_LABEL: 'Meeting Type',
    SCHEDULER_MEETING_TYPES_LABEL: 'Meeting Types',
    SCHEDULER_TEMPLATE_PLACEHOLDER: 'Auswählen',
    SCHEDULER_DURATION_LABEL: 'Dauer',
    SCHEDULER_TOTAL_DURATION_LABEL: 'Gesamtdauer',
    SCHEDULER_DURATION_DIMENSION_MINUTES_FULL_LABEL: 'minuten',
    SCHEDULER_DURATION_DIMENSION_HOURS_FULL_LABEL: 'stunden',
    SCHEDULER_DURATION_DIMENSION_MINUTES_SHORT_LABEL: 'min',
    SCHEDULER_DURATION_DIMENSION_HOURS_SHORT_LABEL: 'h',
    SCHEDULER_DURATION: 'dauer',
    SCHEDULER_BUFFER: 'puffer',
    SCHEDULER_BUFFER_TIME_NONE_LABEL: 'Keine',
    SCHEDULER_BUFFER_TIME_MIN5_LABEL: '5 Min',
    SCHEDULER_BUFFER_TIME_MIN10_LABEL: '10 Min',
    SCHEDULER_BUFFER_TIME_MIN15_LABEL: '15 Min',
    SCHEDULER_BUFFER_TIME_MIN20_LABEL: '20 Min',
    SCHEDULER_BUFFER_TIME_MIN25_LABEL: '25 Min',
    SCHEDULER_BUFFER_TIME_MIN30_LABEL: '30 Min',
    SCHEDULER_BUFFER_TIME_MIN35_LABEL: '35 Min',
    SCHEDULER_BUFFER_TIME_MIN40_LABEL: '40 Min',
    SCHEDULER_BUFFER_TIME_MIN45_LABEL: '45 Min',
    SCHEDULER_BUFFER_TIME_MIN50_LABEL: '50 Min',
    SCHEDULER_BUFFER_TIME_MIN55_LABEL: '55 Min',
    SCHEDULER_BUFFER_TIME_MIN60_LABEL: '60 Min',
    SCHEDULER_BUFFER_LABEL: 'Puffer',
    SCHEDULER_BUFFER_TOOLTIP: 'Blockiert den Kalender des Gastgebers vor und/oder nach diesem Meeting für diese Dauer. Pufferzeiten werden normalerweise für Vorbereitung, Nachbesprechung oder Fahrzeit bei persönlichen Treffen genutzt.',
    SCHEDULER_BUFFER_BEFORE_LABEL: 'Davor',
    SCHEDULER_BUFFER_AFTER_LABEL: 'Danach',
    SCHEDULER_LOCATION_LABEL: 'Ort',
    SCHEDULER_LOCATION_VIDEO_CONFERENCE: 'Videokonferenz',
    SCHEDULER_LOCATION_IN_PERSON: 'Persönlich',
    SCHEDULER_LOCATION_PHONE: 'Telefon',
    SCHEDULER_LOCATION_PHONE_HOST_PHONE: 'Gastgeber',
    SCHEDULER_LOCATION_PHONE_INVITEE_PHONE: 'Eingeladener',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PHONE: 'Benutzerdefiniert',
    SCHEDULER_LOCATION_INTEGRATION_ENABLED_LABEL: 'Videokonferenzdetails einfügen',
    SCHEDULER_LOCATION_INTEGRATION_ZOOM_LABEL: 'Zoom',
    SCHEDULER_LOCATION_INTEGRATION_GOOGLE_MEET_LABEL: 'Google Meet',
    SCHEDULER_LOCATION_INTEGRATION_MICROSOFT_TEAMS_LABEL: 'Microsoft Teams',
    SCHEDULER_LOCATION_PHYSICAL_ADDRESS_PLACEHOLDER: 'Adresse auswählen',
    SCHEDULER_LOCATION_ROOM_PLACEHOLDER: 'Raum',
    SCHEDULER_LOCATION_RESOURCES_PLACEHOLDER: 'Ressourcen',
    SCHEDULER_LOCATION_CUSTOM_ADDRESS_PLACEHOLDER: 'Benutzerdefinierte Adresse eingeben',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PLACEHOLDER: 'Telefonnummer eingeben',
    SCHEDULER_LOCATION_IN_PERSON_LOCATION: 'Standorte der Organisation',
    SCHEDULER_LOCATION_IN_PERSON_CUSTOM_ADDRESS: 'Benutzerdefinierte Adresse',
    SCHEDULER_LOCATION_IN_PERSON_INVITEE_LOCATION: 'Ort des Eingeladenen',
    SCHEDULER_AVAILABILITY_LABEL: 'Verfügbarkeit',
    SCHEDULER_AVAILABILITY_TOOLTIP: 'Im offenen Modus werden dem Hauptgast die meisten verfügbaren Termine angeboten. Mit den zusätzlichen Optionen (benutzerdefiniert, rollierendes Fenster, Datumsbereich) kannst du die verfügbaren Zeitfenster einschränken.',
    SCHEDULER_AVAILABILITY_OPEN: 'Offen',
    SCHEDULER_AVAILABILITY_CUSTOM: 'Benutzerdefiniert',
    SCHEDULER_AVAILABILITY_ROLLING: 'Rollierend',
    SCHEDULER_AVAILABILITY_RANGE: 'Bereich',
    SCHEDULER_AVAILABILITY_OPEN_DESCRIPTION: 'Dieses Meeting kann zu jedem verfügbaren Termin geplant werden, ab dem Zeitpunkt, an dem der Teilnehmer auf den Einladungslink klickt.',
    SCHEDULER_AVAILABILITY_CUSTOM_DESCRIPTION: 'Im Kalender kannst du deine individuelle Verfügbarkeit für diese Einladung festlegen. Teilnehmern werden nur die Zeiten angezeigt, die du freigegeben hast.',
    SCHEDULER_AVAILABILITY_ROLLING_DESCRIPTION: 'Teilnehmern werden verfügbare Zeiten innerhalb eines Zeitraums angezeigt, der beginnt, wenn sie auf den Einladungslink klicken.',
    SCHEDULER_AVAILABILITY_ROLLING_WINDOW_LABEL: 'Fenster (Tage)',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_LABEL: 'Ablauf',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_PLACEHOLDER: 'Nie',
    SCHEDULER_AVAILABILITY_RANGE_DESCRIPTION: 'Wähle einen Datumsbereich der Verfügbarkeit aus.',
    SCHEDULER_AVAILABILITY_RANGE_START_LABEL: 'Start',
    SCHEDULER_AVAILABILITY_RANGE_START_DATE_PLACEHOLDER: 'Startdatum',
    SCHEDULER_AVAILABILITY_RANGE_START_TIME_PLACEHOLDER: 'Startzeit',
    SCHEDULER_AVAILABILITY_RANGE_END_LABEL: 'Ende',
    SCHEDULER_AVAILABILITY_RANGE_END_DATE_PLACEHOLDER: 'Enddatum',
    SCHEDULER_AVAILABILITY_RANGE_END_TIME_PLACEHOLDER: 'Endzeit',
    SCHEDULER_LIMIT_LABEL: 'Limit',
    SCHEDULER_LIMIT_TOOLTIP: 'Begrenze die Anzahl der Termine, die mit dieser Einladung/diesem Link gebucht werden können. Danach läuft die Einladung/dieser Link automatisch ab.',
    SCHEDULER_LIMIT_LIMIT1_LABEL: '1',
    SCHEDULER_LIMIT_LIMIT2_LABEL: '2',
    SCHEDULER_LIMIT_LIMIT3_LABEL: '3',
    SCHEDULER_LIMIT_LIMIT4_LABEL: '4',
    SCHEDULER_LIMIT_LIMIT5_LABEL: '5',
    SCHEDULER_LIMIT_LIMIT6_LABEL: '6',
    SCHEDULER_LIMIT_LIMIT7_LABEL: '7',
    SCHEDULER_LIMIT_LIMIT8_LABEL: '8',
    SCHEDULER_LIMIT_LIMIT9_LABEL: '9',
    SCHEDULER_LIMIT_LIMIT10_LABEL: '10',
    SCHEDULER_LIMIT_UNLIMITED_LABEL: 'Unbegrenzt',
    SCHEDULER_HOST_LABEL: 'Gastgeber',
    SCHEDULER_HOST_PLACEHOLDER: 'Gastgeber hinzufügen',
    SCHEDULER_ADD_GUEST_LABEL: 'Teilnehmer hinzufügen',
    SCHEDULER_ADD_GUEST_PLACEHOLDER: 'Nach Name oder E-Mail suchen',
    SCHEDULER_MAIN_GUEST_LABEL: 'Eingeladener',
    SCHEDULER_NOTE_LABEL: 'Notiz für Eingeladene und Teilnehmer',
    SCHEDULER_MAIN_GUEST_TOOLTIP: 'Wenn der Eingeladene definiert ist, klicke auf „Zeitfenster einfügen & schließen“, um sie in die E-Mail einzufügen. Andernfalls klicke auf „Link kopieren & schließen“, um ihn an jeden zu senden. Der Eingeladene kann sich bei der Buchung identifizieren.',
    SCHEDULER_MAIN_GUEST_PLACEHOLDER: 'Nach Name oder E-Mail suchen',
    SCHEDULER_GUESTS_LABEL: 'Teilnehmer',
    SCHEDULER_DESCRIPTION_LABEL: 'Notiz vom Gastgeber',
    SCHEDULER_INSERT_BUTTON_LABEL: 'Zeitfenster einfügen & schließen',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_LABEL: 'Buchen & schließen',
    SCHEDULER_BOOK_AND_NEW_BUTTON_LABEL: 'Buchen & neu',
    SCHEDULER_INSERT_BUTTON_TOOLTIP: 'Fügt verfügbare Zeitfenster in deine E-Mail ein.',
    SCHEDULER_BOOK_AND_NEW_BUTTON_TOOLTIP: 'Bucht sofort und setzt für eine neue Buchung zurück.',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_TOOLTIP: 'Bucht sofort und schließt den Meeting Booker.',
    SCHEDULER_COPY_LINK_BUTTON_LABEL: 'Link kopieren & schließen',
    SCHEDULER_COPY_LINK_BUTTON_TOOLTIP: 'Kopiert diesen Buchungslink, den du in eine E-Mail einfügen kannst.',
    SCHEDULER_BUTTON_PREVIOUS_WEEK: 'Vorherige Woche',
    SCHEDULER_BUTTON_NEXT_WEEK: 'Nächste Woche',
    SCHEDULER_BUTTON_THIS_WEEK: 'Diese Woche',
    SCHEDULER_BUTTON_TODAY: 'Heute',
    SCHEDULER_ERROR: 'Fehler',
    INTERNAL_SERVER_ERROR: 'Interner Serverfehler',
    INTERNAL_SERVER_ERROR_ALERT: 'Die Öffnung in WEISS wird in die Einladung eingefügt.',
    SCHEDULER_CREATE_BOOKING_PAGE_ERROR: 'CreateBookingPage-Anfrage fehlgeschlagen. Bitte später erneut versuchen',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_ERROR: 'Bitte Upgrade durchführen, du hast das Limit erreicht.',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_LINK: 'Pläne anzeigen',
    SCHEDULER_MEMBERS_ERROR: 'Mitgliederanfrage fehlgeschlagen. Bitte später erneut versuchen',
    SCHEDULER_TEMPLATE_ERROR: 'Vorlagenanfrage fehlgeschlagen. Bitte später erneut versuchen',
    GET_USER_LOGIN_ERROR_MESSAGE: 'Kein Konto mit dieser E-Mail vorhanden',
    GET_USER_AUTH_ERROR_MESSAGE: 'Benutzeranmeldung fehlgeschlagen',
    GET_USER_LOGOUT_ERROR_MESSAGE: 'Benutzer-Abmeldung fehlgeschlagen',
    DELETE_USER_SUCCESS_MESSAGE: 'Authentifizierungsanfrage fehlgeschlagen',
    DELETE_USER_ERROR_MESSAGE: 'Benutzer-Löschanfrage fehlgeschlagen',
    CHOOSE_AN_ACCOUNT_ERROR_TOAST: 'Kontoauswahl fehlgeschlagen',
    GET_MAIN_DATA_ERROR_MESSAGE: 'Authentifizierungsanfrage fehlgeschlagen',
    ROLE_DEACTIVATED_ERROR_MESSAGE: 'Rolle wurde deaktiviert. Bitte kontaktiere deinen Omnito-Administrator.',
    USER_DEACTIVATED_ERROR_MESSAGE: 'Benutzer wurde deaktiviert. Bitte kontaktiere deinen Omnito-Administrator.',
    TRIAL_LIMIT_ERROR_MESSAGE: 'Du hast das Limit von 40 Elementen in der Testversion überschritten',
    ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE: 'Ein anderes Konto ist bereits mit dieser E-Mail verknüpft',
    DELETE_ROLE_ASSIGNED_ERROR_MESSAGE: 'Kann nicht gelöscht werden. Benutzer sind dieser Rolle zugewiesen.',
    INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE: 'Ungültiger Google API-Schlüssel oder erforderliche Dienste nicht aktiviert.',
    IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE: 'Import fehlgeschlagen: Limit von 100 Standorten überschritten. Bitte Datei aufteilen.',
    PRICING_TIER_ACCESS_EXCEPTION_MESSAGE: 'Bitte aktualisiere deinen Aboplan, um auf diese Funktion zuzugreifen.',
    RESEND_USER_INVITE_ERROR_MESSAGE: 'Admin-Datensatz mit dieser E-Mail existiert bereits für diese Organisation',
    ACTIVE_TAB_SIDEBAR_LICENSE_ERROR: 'Deine Lizenz ist abgelaufen. Bitte überprüfe dein Abonnement.',
    PLEASE_WAIT_AND_TRY_AGAIN: 'Bitte warten und erneut versuchen',
    FAILED_TO_LOAD_SCHEDULER_DATA: 'Fehler beim Laden der Scheduler-Daten...',
    MEETING_BOOKER_INSTALLED: 'Meeting Booker ist installiert.',
    TRY_AGAIN: 'Erneut versuchen',
    SPOTS_WIDGET_CLICK_HERE: 'Hier klicken',
    SPOTS_WIDGET_VIEW_MORE_OPTIONS: 'um mehr Optionen zu sehen',
    SPOTS_WIDGET_SELECT_TIME_SLOT: 'um verfügbares Zeitfenster auszuwählen',
    SCHEDULER_COPY_LINK: 'Link kopieren',
    SCHEDULER_ADD_INVITEE: 'Eingeladene hinzufügen',
    SCHEDULER_ADD_ATTENDEE: 'Teilnehmer hinzufügen',
    SEARCH_ATTENDEE_PLACEHOLDER: 'Suchen oder eingeben, um Teilnehmer hinzuzufügen',
    SEARCH_HOST_PLACEHOLDER: 'Suchen oder eingeben, um Gastgeber auszuwählen',
    SHOW_WEEKENDS: 'Wochenenden anzeigen',
    INVITEE_AMD_ATTENDEES: 'Eingeladene und Teilnehmer',
    SCHEDULER_BOOKING_TOOLS: 'Buchungs-Tools',
    SCHEDULER_USER_SETTINGS: 'Benutzereinstellungen',
    SCHEDULER_ALL_PERSONAL_LINKS: 'Alle persönlichen Links',
    SCHEDULER_TOOLS: 'Tools',
    SCHEDULER_TEMPLATES: 'Vorlagen',
    SCHEDULER_TOOLS_AVAILABILITY: 'Verfügbarkeit',
    SCHEDULER_TOOLS_INTEGRATE: 'Integrationen',
    SCHEDULER_TOOLS_BOOKING_PAGES: 'Meeting-Typen',
    SCHEDULER_TOOLS_MY_BOOKING_PAGES: 'Meine Meeting-Typen',
    SCHEDULER_TOOLS_SHARED_BOOKING_PAGES: 'Geteilte Meeting-Typen',
    SCHEDULER_HEADER_TAB_1: 'Buchungszeit anbieten',
    SCHEDULER_HEADER_TAB_2: 'Sofortmeeting',
    SCHEDULER_DEFAULT_INVITEE_NAME_LABEL: 'Name',
    SCHEDULER_DEFAULT_INVITEE_EMAIL_LABEL: 'E-Mail',
    SCHEDULER_GUIDE_TITLE: 'Willkommen bei Meeting Booker',
    SCHEDULER_ONBOARDING: 'Onboarding starten',
    SCHEDULER_SKIP: 'Überspringen',
    SCHEDULER_GUIDE_DESCRIPTION: 'Plane Meetings mühelos – direkt aus deiner E-Mail. Wähle deine Verfügbarkeit, füge Zeitfenster in deine Nachricht ein und lass andere auswählen, was am besten passt.',
    SCHEDULER_GUIDE_HOW_IT_WORKS: 'So funktioniert es',
    SCHEDULER_GUIDE_STEP_1_TITLE: 'Schritt 1: Anmelden oder Konto erstellen',
    SCHEDULER_GUIDE_STEP_1_DESCRIPTION: 'Verwende deine E-Mail, um dich anzumelden oder schnell ein neues Konto zu erstellen, um mit Meeting Booker zu starten.',
    SCHEDULER_GUIDE_STEP_2_TITLE: 'Schritt 2: Neue E-Mail erstellen',
    SCHEDULER_GUIDE_STEP_2_DESCRIPTION: 'Verfasse eine E-Mail und klicke auf das Meeting Booker-Symbol in der Toolbar.',
    SCHEDULER_GUIDE_STEP_3_TITLE: 'Schritt 3: Meeting einrichten',
    SCHEDULER_GUIDE_STEP_3_DESCRIPTION: 'Wähle Dauer, Meeting-Typ, Zeitfenster, Eingeladene und füge eine Notiz hinzu – alles synchronisiert mit deinem Kalender.',
    SCHEDULER_GUIDE_STEP_4_TITLE: 'Schritt 4: Zeitfenster in deine E-Mail einfügen',
    SCHEDULER_GUIDE_STEP_4_DESCRIPTION: 'Klicke auf „Zeitfenster einfügen & schließen“ – wir fügen deine Verfügbarkeit direkt in die Nachricht ein. Sende sie und lass die anderen auswählen!',
    SCHEDULER_GUIDE_GET_STARTED_BUTTON: 'Loslegen',
    SCHEDULER_BOOKED_SUCCESS_MESSAGE: 'Dein Termin ist gebucht!',
    SCHEDULER_BOOKED_SUCCESS_MESSAGE_CHECK_INBOX: 'Prüfe dein Postfach für eine E-Mail mit allen Details.',
    SCHEDULER_BOOKED_ERROR_MESSAGE: 'Zeitfenster erforderlich',
    SCHEDULER_BOOKED_ERROR_MESSAGE_PICK_TIME_SLOT: 'Bitte wähle ein Zeitfenster im Kalender, um dein Meeting zu buchen.',
    CHARACTER_LIMIT_REACHED: 'Limit erreicht',
    SCHEDULER_TIME_SLOT_TO_SHORT_TITLE: 'Bitte wähle ein größeres Zeitfenster im Kalender.',
    SCHEDULER_TIME_SLOT_TO_SHORT_DESCRIPTION: `Dieses Zeitfenster ist zu kurz. Dein Meeting erfordert ${ReplacesEnum_1.ReplacesDetailEnum.DURATION}.`,
    SCHEDULER_TIMEZONE_NOT_SELECTED_TITLE: 'Zeitzone nicht ausgewählt',
    SCHEDULER_TIMEZONE_NOT_SELECTED_DESCRIPTION: 'Bitte wähle eine Zeitzone aus dem Kalender-Dropdown, bevor du Zeitfenster einfügst.',
    NO_ACTIVE_WORKSPACES_TITLE: 'Keine aktiven Arbeitsbereiche',
    NO_ACTIVE_WORKSPACES: 'Es gibt momentan keine aktiven Arbeitsbereiche. Wir sind sicher, dass dies bald behoben wird – bitte später erneut prüfen oder deinen Administrator kontaktieren.',
    WEEKDAYS_ONLY: 'Nur Werktage',
    INCLUDE_WEEKENDS: 'Wochenenden einschließen',
    SUCCESS: 'Erfolg',
    ERROR: 'Fehler',
    INFO: 'Info',
    WARNING: 'Warnung',
    CALENDAR_DISPLAY: 'Kalenderanzeige',
    MY_BOOKING_PAGES: 'Meine Meeting-Typen',
    SHARED_BOOKING_PAGES: 'Geteilte Meeting-Typen',
    SCHEDULER_MY_MEETINGS_LABEL: 'My Meetings',
    SCHEDULER_SHARED_MEETINGS_LABEL: 'Shared with me',
    SCHEDULER_TEAM_LABEL: 'Team',
    SCHEDULER_ROUND_ROBIN_LABEL: 'Round-Robin',
    SCHEDULER_POOL_LABEL: 'Pool',
    SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS: 'Benutzer hat nicht die erforderlichen Berechtigungen',
    CORS_CONFIGURATION_REQUIRED_TITLE: 'CORS-Konfiguration erforderlich',
    CORS_CONFIGURATION_REQUIRED_TEXT: 'Zugriff auf Benutzerinformationen ist durch Salesforce CORS-Einstellungen blockiert. Kontaktiere deinen Salesforce-Administrator, um dieses Problem zu beheben.',
    GMAIL_CONTACTS_TOOLTIP: 'Gmail Kontakte',
    OUTLOOK_CONTACTS_TOOLTIP: 'Outlook Kontakte',
    SALESFORCE_TOOLTIP: 'Salesforce',
    SALESFORCE_LEAD_TOOLTIP: 'Lead',
    SALESFORCE_CONTACT_TOOLTIP: 'Contact',
    SALESFORCE_PERSON_ACCOUNT_TOOLTIP: 'Person Account',
    SALESFORCE_TEAM_TOOLTIP: 'Team',
    SALESFORCE_RESOURCE_TOOLTIP: 'Resource',
    SALESFORCE_BUCKET_TOOLTIP: 'Bucket',
    SALESFORCE_USER_TOOLTIP: 'User',
    HUBSPOT_TOOLTIP: 'HubSpot',
    SUMO_FOR_SALESFORCE_CEP_TOOLTIP: 'Omnito für Salesforce (CEP)',
    SERVICE_NOW_TOOLTIP: 'ServiceNow',
    SCHEDULER_MINIMUM_NOTICE_PERIOD_LABEL: 'Mindestfrist',
    SCHEDULER_DURATION_WARNING: 'Warnung: Die Gesamtdauer ist kürzer als die der ausgewählten Dienste.',
    SCHEDULER_HOST_LIMIT_WARNING: 'Der aktuell ausgewählte Gastgeber hat sein persönliches Terminlimit für den ausgewählten Termintyp überschritten.',
    SCHEDULER_BUSY: 'Beschäftigt',
    // Login
    LOGIN_OR: 'oder',
    LOGIN_EMAIL_PLACEHOLDER: 'E-Mail-Adresse eingeben',
    LOGIN_CONTINUE: 'Weiter',
    LOGIN_BACK: 'Zurück',
    LOGIN_PASSWORD_LABEL: 'Passwort',
    LOGIN_BUTTON: 'Anmelden',
    LOGIN_FORGOT_PASSWORD: 'Passwort vergessen?',
    LOGIN_SEND_RECOVERY_EMAIL: 'E-Mail zur Wiederherstellung senden',
    FORGOT_PASSWORD_SUCCESS_MESSAGE: 'Wiederherstellungs-E-Mail gesendet! Überprüfen Sie Ihren Posteingang für einen Link zum Zurücksetzen Ihres Passworts.',
    LOGIN_INVALID_EMAIL: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    LOGIN_INVALID_PASSWORD: 'Bitte geben Sie Ihr Passwort ein',
    LOGIN_NO_ACCOUNT: 'Kein Konto mit dieser E-Mail gefunden.',
    // MFA (TOTP)
    MFA_TITLE: 'Zwei-Faktor-Authentifizierung',
    MFA_SUBTITLE: 'Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.',
    MFA_VERIFY: 'Bestätigen',
    MFA_SAVE_THIS_DEVICE: 'Dieses Gerät speichern',
    MFA_INCORRECT_CODE: 'Falscher Code. Bitte versuchen Sie es erneut.',
});
